module.exports = __webpack_public_path__ + "static/media/model-preview.761c479b.png";